var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoKvhLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240.035,
    height: 54.701,
    viewBox: "0 0 240.035 54.701",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.218,
    y1: 0.782,
    x2: 0.782,
    y2: 0.218,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbae17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec1c28"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_5815",
    x: 18.104,
    y: 0,
    width: 54.664,
    height: 54.665,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.596
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.218,
    y1: 0.782,
    x2: 0.782,
    y2: 0.218,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f69a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b75bb"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_5816",
    x: 0,
    y: 0.037,
    width: 54.665,
    height: 54.664,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2670",
    "data-name": "Group 2670",
    transform: "translate(-931 -268)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "KVH_Link",
    "data-name": "KVH Link",
    transform: "translate(1016.035 306)",
    fill: "#fff",
    fontSize: 37,
    fontFamily: "ArialMT, Arial"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "KVH Link")), /*#__PURE__*/React.createElement("g", {
    id: "Group_833",
    "data-name": "Group 833",
    transform: "translate(934 269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_833-2",
    "data-name": "Group 833",
    transform: "translate(18.104 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -21.1, -1)",
    filter: "url(#Path_5815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5815-2",
    "data-name": "Path 5815",
    d: "M72.521,69.7,65.892,63.07l3.133-3.134,3.5,3.494L93.71,42.241,78.769,27.3,57.58,48.49l3.5,3.494-3.134,3.133L51.313,48.49,78.769,21.033,99.977,42.241Z",
    transform: "translate(-30.21 -20.03)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_834",
    "data-name": "Group 834",
    transform: "translate(0 0.037)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3, -1.04)",
    filter: "url(#Path_5816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5816-2",
    "data-name": "Path 5816",
    d: "M48.011,69.747,26.8,48.539,54.26,21.083l6.628,6.628-3.133,3.134L54.26,27.35,33.07,48.539l14.94,14.94L69.2,42.29,65.706,38.8l3.133-3.134,6.628,6.628Z",
    transform: "translate(-23.8 -20.05)",
    fill: "url(#linear-gradient-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKvhLink);
export default __webpack_public_path__ + "static/media/logo_KVHLink.b454396230e4f5c8aa48b6d9568149fb.svg";
export { ForwardRef as ReactComponent };